import React from "react";
type TextAlignLeftProps = {
  color?: string;
};

const TextAlignLeft: React.FC<TextAlignLeftProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16569_13863)">
        <path
          d="M15 15H3V17H15V15ZM15 7H3V9H15V7ZM3 13H21V11H3V13ZM3 21H21V19H3V21ZM3 3V5H21V3H3Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_16569_13863">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TextAlignLeft;
